import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import Color from "./Color";
import { Header } from './Header';
import { Footer } from './Footer';

export default class Colors extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            controllerName: 'constant',
            data: null,
            loading: true,
            configName: 'colors_grid',
            moduleName: 'رنگها'
        };
    }
    componentDidMount() {
        this.refreshLis();
    }
    refreshLis() {
        this.refreshData(null,"list/5");
    }
    onEdit(id) {
        this.showComponents({ component: <Color Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <Color Caller={this} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "title", caption: "عنوان", show: true },
                { field: "titleAr", caption: "عنوان عربی", show: true },
                { field: "titleEn", caption: "عنوان لاتین", show: true },
                { field: "addDateString", caption: "تاریخ ثبت", show: true },
                { field: "editDateString", caption: "تاریخ بروزرسانی", show: true }
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'title' && f.show) t.push({ field: f.field, headerName: f.caption, cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.onEdit(props.data.id)}>{props.data.title}</a> } });
            if (f.field == 'titleAr' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'titleEn' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'addDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'editDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
        });
        return t;
    }
    renderForm() {
        return <div className="nk-content-body">
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        <div className="card-inner-group">
                            <div className="card-inner p-0">
                                {this.getToolBar()}
                                {this.renderAgGrid({
                                    columnDefs: this.getColumns()
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}